<template>
    <!-- First name input field -->
    <div :class="firstNameInputClass">
        <label class="input__label" for="first-name" v-text="label || $t('ACCOUNT_FORM_FIRST_NAME')"></label>
        <input
            id="first-name"
            name="name"
            autocomplete="name"
            type="text"
            class="input__field"
            v-model="firstName">

        <!-- Validation -->
        <p class="input__message" v-if="showFirstNameRequiredValidationMessage"
           v-html="$t('ACCOUNT_FORM_PLEASE_PUT_FIRST_NAME')"/>

        <!-- Validation -->
        <p class="input__message" v-if="showFirstNameValidAlphabetStringValidationMessage"
           v-html="$t('ACCOUNT_FORM_HMM')"/>
    </div>
</template>
<script>
import required from 'vuelidate/src/validators/required';
import { isValidAlphabetString } from '@/validators/StringValidator';

export default {
    name: 'FirstNameField',
    props: {
        value: {
            default: null,
            type: String,
        },
        label: {
            default: null,
            type: String,
        },
    },
    data() {
        return {
            firstName: null,
            selectedLabel: null,
        };
    },
    computed: {
        firstNameInputClass() {
            if (this.firstName === null) return 'input';

            return this.isFirstNameValid ? 'input input--success' : 'input input--invalid';
        },

        isFirstNameValid() {
            return !this.$v.firstName.$invalid;
        },

        showFirstNameRequiredValidationMessage() {
            return this.firstName !== null && !this.$v.firstName.required;
        },

        showFirstNameValidAlphabetStringValidationMessage() {
            if (this.showFirstNameRequiredValidationMessage) return false;

            return this.firstName !== null && !this.$v.firstName.isValidAlphabetString;
        },
    },
    mounted() {
        this.firstName = this.value;
    },
    methods: {
        /**
         * Sync with parent component.
         *
         * @returns {void}
         */
        updateInput() {
            this.$emit('input', this.firstName);
            this.$emit('update:validation', this.isFirstNameValid);
        },
    },
    validations: {
        firstName: {
            required,
            isValidAlphabetString,
        },
    },
    watch: {
        firstName() {
            this.updateInput();
        },
        value(newValue) {
            if (newValue !== this.firstName) {
                this.firstName = newValue;
            }
        },
    },
};
</script>
